/* eslint-disable */
import { CommonPost, CommonGet } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    SaveUser,
    getUserByID,
    UpdateUser,
    GetAllGroups,
    GetFactoriesByGroupID
};

async function SaveUser(data) {
    const body = {
        userTypeID: parseInt(data.userTypeID),
        roleID: parseInt(data.roleID),
        userName: data.userName,
        firstName: data.firstName,
        secondName: data.secondName,
        lastName: data.lastName,
        password: data.password,
        nIC: data.nIC,
        address1: data.address1,
        address2: data.address2,
        mobileNumber: parseInt(data.mobileNumber),
        province: parseInt(data.province),
        district: parseInt(data.district),
        city: parseInt(data.city),
        groupID: parseInt(data.groupID),
        factoryID: parseInt(data.factoryID),
        isLock: data.isLock,
        isActive: data.isActive,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }

    const response = await CommonPost('/api/Auth/Register', null, body);
    return response;
}

async function getUserByID(userID) {
    const response = await CommonGet('/api/User/getUserDetailsByID', 'userID=' + parseInt(userID));
    return response.data;
}

async function UpdateUser(data, userID) {
    const body = {
        userTypeID: parseInt(data.userTypeID),
        roleID: parseInt(data.roleID),
        userName: data.userName,
        firstName: data.firstName,
        secondName: data.secondName,
        lastName: data.lastName,
        password: data.password,
        nIC: data.nIC,
        address1: data.address1,
        address2: data.address2,
        mobileNumber: parseInt(data.mobileNumber),
        province: parseInt(data.province),
        district: parseInt(data.district),
        city: parseInt(data.city),
        groupID: parseInt(data.groupID),
        factoryID: parseInt(data.factoryID),
        isLock: data.isLock,
        isActive: data.isActive,
        userID: userID,
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Auth/UpdateUser', null, body);
    return response;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}